@if(isDisabled){
<app-loader></app-loader>
}
<form name="ClusterForm" (ngSubmit)="ClusterForm.form.valid && Save()" #ClusterForm="ngForm">
    <div class="card">
        <div class="card-header">
            Change Employee Password
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-6 px-1">
                    <label class="form-label">Employee Type : </label>
                    <div class="btn-group btn-group-toggle">
                        <label class="form-check-label link-dark px-1" ngbButtonLabel>
                            <input class="form-check-input" type="radio" value='front' name='EMPType'
                                [(ngModel)]="Detail.EmpType"  (change)="Clear()" 
                                [ngModelOptions]="{standalone: true}">
                            Front
                        </label>
                        <label class="form-check-label link-dark px-1" ngbButtonLabel>
                            <input class="form-check-input" type="radio" value='back' name='EMPType'
                                [(ngModel)]="Detail.EmpType"  (change)="Clear()"
                                [ngModelOptions]="{standalone: true}">
                            Back
                        </label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-5 px-1">
                    <label>Employee Code<span class="text-danger">*</span></label>
                    <input name="Code" maxlength="100" class="form-control" placeholder="Ex." [(ngModel)]="Detail.Code"
                        #Code="ngModel" (change)="Clear(false)">
                    <div class="invalid-feedback">
                        Please enter Code.
                    </div>
                </div>
                <div class="col-md-3 px-1"><br>
                    <button type="button" name="search" class="btn btn-primary" [disabled]="isDisabled"
                        (click)="ComboLoad('ChangePassword')"><i class="bi bi-search" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Search':'Loading...'}}</button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-8 px-1">
                    <label class="form-label text-label-dark" style="text-decoration: underline;">{{this.Detail.EmployeeName ? this.Detail.EmployeeName :
                        ''}}</label>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-md-3 px-1">
                    <label>Password<span class="text-danger">*</span></label>
                </div>
                <div class="col-md-5 px-1 mt-2">
                    <input name="password" maxlength="200" class="form-control" placeholder=""
                        [(ngModel)]="Detail.NewPassword" #password="ngModel" type="password" required>
                    <div class="invalid-feedback">
                        Please enter Password.
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3 px-1">
                    <label>Confirm Password<span class="text-danger">*</span></label>
                </div>
                <div class="col-md-5 px-1 mt-2">
                    <input name="confirmpassword" maxlength="200" class="form-control" placeholder=""
                        [(ngModel)]="Detail.ConfirmPassword" #confirmpassword="ngModel" required>
                    <div class="invalid-feedback">
                        Please enter confirm Password.
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col">
                </div>
                <div class="col-auto">
                    <div class="col-auto">
                        <button *ngIf="this.common.PageRight.IsEdit" type="submit" name="sub" class="btn btn-primary"
                            [disabled]="isDisabled"><i class="bi bi-pencil-square" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Change Password':'Loading...'}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>